export const selectAddressesByTypeKey = (state, addressType) => {
    return state.addresses[addressType];
};
